<script>
import {
  exportExcelNew,
  getDeviceList,
  GetDeviceLoadedRateListByMonth,
  getDeviceModelTablePage,
  getExportDeviceList
} from "@/api/api";
import {mapGetters, mapState} from "vuex";

export default {
  name: "LoadedRateStatistics",
  data() {
    return {
      monthData: this.getLastMonthFormatted(),
      pickerBeginDateBefore: {
        disabledDate(time) {
          const date1 = new Date("2025-05-01");
          const date2 = new Date(
              new Date().getFullYear() +
              "-" +
              ("0" + (new Date().getMonth() + 1)).substr(-2) +
              "-" +
              ("0" + new Date().getDate()).substr(-2)
          );
          const diff = date2 - date1 + 60 * 60 * 24 * 1000;
          const diff2 = -new Date().getDate() * 60 * 60 * 24 * 1000;
          return (
              time.getTime() < Date.now() - diff || Date.now() < time.getTime() - diff2
          );
        },
      },
      timeDefaultShow: new Date(),
      formselect: {
        dsn: "",
        gsn: "",
      },
      tableData1: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      loading: false,
      modelCategoryNames: []
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  mounted: function () {
    this.getDeviceList();
    let PostData = {
      KeyWord: "2",
      SkipCount: 0,
      MaxResultCount: 100000
    };
    let that = this;
    getDeviceModelTablePage(PostData).then((res) => {
      let data = res.result;
      let map = data.items.map((item) =>
        item.kProduct
      );
      that.modelCategoryNames = map;
    });
  },
  methods: {
    getLastMonthFormatted() {
      const date = new Date();
      date.setDate(1);
      date.setMonth(date.getMonth() - 1);

      const year = date.getFullYear(); // 获取年份
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份并补零
      const day = String(date.getDate()).padStart(2, '0'); // 获取日期并补零

      return `${year}-${month}`;
    },

    exportDeviceList() {
      let that = this;
      that.loading = true;

      var fileName = that.$t("desc.deviceLoadedList")+".csv";
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        SkipCount: 0,
        MaxResultCount: 10000
      };
      GetDeviceLoadedRateListByMonth(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          let header = [
            that.$t('desc.airCompressorSN'),
            that.$t('desc.gatewaySN'),
            that.$t('title.brand'),
            that.$t('desc.customer'),
            that.$t('desc.uploadUnLoadChangeCount'),
            that.$t('title.loadRate'),
            that.$t('desc.UtilizationRate'),
            that.$t('desc.cycle'),
            that.$t('title.ModelCategoryName'),
            that.$t('ota.DeviceModel'),
            that.$t('desc.CustomerBigRegion'),
            that.$t('title.customerCenter'),
            that.$t('station.industryName'),
          ];
          let exportContent = new Array();
          dataSource.forEach((item) => {
            let rowData = new Object();
            rowData = {
              dsn: item.dsn,
              gsn: item.gsn,
              brandCode:item.brandCode,
              customerName: item.customerName,
              uploadUnLoadChangeCount: item.uploadUnLoadChangeCount,
              loadRate: item.loadRate,
              rate: item.rate,
              cycle: item.cycle,
              modelCategoryName: item.modelCategoryName,
              modelDesc: item.modelDesc,
              customerCenter: item.customerCenter,
              industryName: item.industryName,
              customerBigRegion: item.customerBigRegion
            };
            exportContent.push(rowData);
          });
          // CsvExportor.downloadCsv(exportContent,{header},fileName);
          exportExcelNew({ header }, fileName, exportContent);
          that.loading = false;
        }
      });
    },

    getLastMonthDate() {
        const date = new Date(); // 获取当前日期
        date.setDate(1); // 将日期设置为当月的第一天
        date.setMonth(date.getMonth() - 1); // 将月份减去 1，得到上个月
        return date; // 返回上个月的日期
    },
    async getDeviceList() {
      let that = this;
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
        cycle: this.monthData,
        customerName: this.formselect.customerName,
        modelCategoryName: this.formselect.modelCategoryName
      };
      GetDeviceLoadedRateListByMonth(postData)
          .then((res) => {
            let data = res.result.items;
            this.pagination.totalPage = res.result.totalCount;
            that.tableData1 = data;
          })
          .catch((err) => {});
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    },
    resetKeyword() {
      this.formselect = {};
    },
    async changeMonth() {
      this.getDeviceList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDeviceList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDeviceList();
    },
  },
}
</script>

<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
              ref="formselect"
              :model="formselect"
              class="queryform_div"
              label-width="80px"
          >
            <el-row :gutter="24">
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.airCompressorSN')" label-width="100px">
                  <el-input
                      type="text"
                      placeholder=" "
                      v-model="formselect.dsn"
                      size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewaySN')">
                  <el-input
                      type="text"
                      placeholder=" "
                      v-model="formselect.gsn"
                      size="small"
                  />
                </el-form-item>
              </el-col>

              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('desc.customer')">
                  <el-input
                      type="text"
                      placeholder=" "
                      v-model="formselect.customerName"
                      size="small"
                  />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="6">
                <el-form-item :label="$t('sim.month')">
                  <el-date-picker
                      style="width: 100%"
                      v-model="monthData"
                      type="month"
                      align="right"
                      unlink-panels
                      value-format="yyyy-MM"
                      :picker-options="pickerBeginDateBefore"
                      :default-value="timeDefaultShow"
                      :clearable="false"
                      @blur="changeMonth"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="6">
                <el-form-item :label="$t('title.ModelCategoryName')">
                  <el-select
                      size="small"
                      v-model="formselect.modelCategoryName"
                      :placeholder="$t('desc.select')"
                  >
                    <el-option
                        value=""
                        :label="$t('desc.select')"
                    ></el-option>
                    <el-option v-for="item in modelCategoryNames"
                        :value="item"
                        :label="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>



              <el-col :md="18" :xs="24" :sm="12">
                <el-form-item label=" ">
                  <el-button
                      type="primary"
                      @click="getDeviceList()"
                      size="small"
                  >{{ $t("button.query") }}</el-button
                  >
                  <el-button @click="resetKeyword" size="small">{{
                      $t("button.reset")
                    }}</el-button>
                  <el-button
                      type="default"
                      icon="el-icon-download"
                      style="margin-bottom: 10px"
                      @click="exportDeviceList()"
                      :loading="loading"
                  >{{ $t("button.exportAll") }}</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="clear"></div>
          <div class="tableDiv">
            <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
            >
              <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
              >
              </el-table-column>
              <el-table-column
                  prop="dsn"
                  :label="$t('desc.airCompressorSN')"
                  width="140"
                  fixed="left"
              >
              </el-table-column>
              <el-table-column
                  prop="gsn"
                  :label="$t('desc.gatewaySN')"
                  width="150"
              >
              </el-table-column>

              <el-table-column
                  prop="brandCode"
                  :label="$t('title.brand')"
                  min-width="80"
              >
              </el-table-column>
<!--              <el-table-column
                  prop="deviceType"
                  :label="$t('title.productLine')"
                  width="270"
              >
              </el-table-column>-->

              <el-table-column
                  prop="customerName"
                  :label="$t('desc.customer')"
                  width="310"
              >
              </el-table-column>

              <el-table-column
                  prop="uploadUnLoadChangeCount"
                  :label="$t('desc.uploadUnLoadChangeCount')"
                  width="140"
              >
              </el-table-column>
              <el-table-column
                  prop="loadRate"
                  :label="$t('title.loadRate')"
                  width="200"
              >
                <template slot-scope="scope">
                  <label>
                    {{ scope.row.loadRate ? scope.row.loadRate + '%' :  '' }}
                  </label>
                </template>
              </el-table-column>

              <el-table-column
                  prop="rate"
                  :label="$t('desc.UtilizationRate')"
                  width="120"
              >
                <template slot-scope="scope">
                  <label>
                    {{ scope.row.rate ? scope.row.rate + '%' :  '' }}
                  </label>
                </template>
              </el-table-column>


              <el-table-column
                  prop="cycle"
                  :label="$t('desc.cycle')"
                  width="150"
              >
              </el-table-column>
              <el-table-column
                  prop="modelCategoryName"
                  :label="$t('title.ModelCategoryName')"
                  width="120"
              >
              </el-table-column>

              <el-table-column
                  prop="modelDesc"
                  :label="$t('ota.DeviceModel')"
                  width="160"
              >
              </el-table-column>
              <el-table-column
                  prop="customerBigRegion"
                  :label="$t('desc.CustomerBigRegion')"
                  width="160"
              >
              </el-table-column>
              <el-table-column
                  prop="customerCenter"
                  :label="$t('title.customerCenter')"
                  width="200"
              >
              </el-table-column>


<!--              <el-table-column
                  prop="calcRunningTime"
                  :label="$t('title.RunningTime')"
                  width="200"
              >
              </el-table-column>
              <el-table-column
                  prop="calcLoadedTime"
                  :label="$t('title.LoadedTime')"
                  width="200"
              >
              </el-table-column>
              <el-table-column
                  prop="subRunningTime"
                  :label="$t('title.SubRunningTime')"
                  width="200"
              >
              </el-table-column>
              <el-table-column
                  prop="subLoadedTime"
                  :label="$t('title.SubLoadedTime')"
                  width="150"
              >
              </el-table-column>-->

              <el-table-column
                  prop="industryName"
                  :label="$t('station.industryName')"
                  width="120"
              >
              </el-table-column>
              <<!--el-table-column
                  prop="uploadRunRecordCount"
                  :label="$t('desc.uploadRunRecordCount')"
                  width="140"
              >
              </el-table-column>
              <el-table-column
                  prop="uploadRunLoadedCount"
                  :label="$t('desc.uploadRunLoadedCount')"
                  width="120"
              >
              </el-table-column>
              <el-table-column
                  prop="uploadRunUnloadCount"
                  :label="$t('desc.uploadRunUnloadCount')"
                  width="140"
              >
              </el-table-column>-->

            </el-table>
            <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
            >
            </el-pagination>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>

<style scoped>
.infodiv {
  margin-top: 5px;
  border: 1px solid #d2d2d2;
  padding: 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}

.el-table__fixed-right {
  right: 0px !important;
}

.NoRaidoLabel .el-table__row .el-radio__label {
  display: none;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
</style>